<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { ArticleTag } from '@/api'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ForeignKey({
              service: ArticleTag,
              label: 'Tagi artykułów',
              modelPath: [this, 'form', 'article_tags'],
              multiple: true,
              labelField: 'name',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
